import Button from '../../../components/common/Button'
import type { YoutubeVideo } from './YoutubeVideoForm'
import './YoutubeVideoTable.css'

interface YoutubeVideoTableProps {
  videos: YoutubeVideo[]
  onEdit: (video: YoutubeVideo) => void
  onDelete: (video: YoutubeVideo) => void
  onToggleStatus: (video: YoutubeVideo) => void
}

function YoutubeVideoTable({ videos, onEdit, onDelete, onToggleStatus }: YoutubeVideoTableProps) {
  const formatDate = (dateString: string): string => {
    const date = new Date(dateString)
    return date.toLocaleDateString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
  }

  if (videos.length === 0) {
    return (
      <div className="empty-state">
        <p>Aucune video YouTube</p>
      </div>
    )
  }

  return (
    <div className="youtube-video-table-container">
      <table className="youtube-video-table">
        <thead>
          <tr>
            <th>Apercu</th>
            <th>Titre</th>
            <th>Categorie</th>
            <th>Statut</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {videos.map((video) => (
            <tr key={video.id}>
              <td className="thumbnail-cell">
                <div className="thumbnail-wrapper">
                  <img
                    src={video.thumbnail_url}
                    alt={video.title}
                    className="video-thumbnail"
                  />
                  <div className="play-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </td>
              <td className="title-cell">
                <div className="video-title">{video.title}</div>
                {video.description && (
                  <div className="video-description">
                    {video.description.length > 80
                      ? video.description.substring(0, 80) + '...'
                      : video.description}
                  </div>
                )}
                <div className="video-id-small">
                  <a
                    href={video.youtube_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="youtube-link"
                  >
                    {video.video_id}
                  </a>
                </div>
              </td>
              <td className="category-cell">
                {video.category_name || (
                  <span className="no-category">Sans categorie</span>
                )}
              </td>
              <td className="status-cell">
                <button
                  className={`status-badge status-${video.status}`}
                  onClick={() => onToggleStatus(video)}
                  title="Cliquer pour changer le statut"
                >
                  {video.status === 'published' ? 'Publie' : 'Brouillon'}
                </button>
              </td>
              <td className="date-cell">
                {formatDate(video.created_at)}
              </td>
              <td className="actions-cell">
                <div className="action-buttons">
                  <Button
                    variant="outline"
                    size="small"
                    onClick={() => window.open(video.youtube_url, '_blank')}
                    title="Voir sur YouTube"
                  >
                    ↗
                  </Button>
                  <Button
                    variant="outline"
                    size="small"
                    onClick={() => onEdit(video)}
                    title="Modifier"
                  >
                    ✏️
                  </Button>
                  <Button
                    variant="outline"
                    size="small"
                    onClick={() => {
                      if (confirm(`Supprimer "${video.title}" ?`)) {
                        onDelete(video)
                      }
                    }}
                    title="Supprimer"
                  >
                    🗑️
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default YoutubeVideoTable
